import { Card } from '@ipfabric/ui-components/Card/Card';
import { Table } from 'components/Table/components/Table';
import { renderQuery } from 'utils/react-query/renderQuery';
import { DataPolicyForm } from './DataPolicyForm/DataPolicyForm';
import { ManageEnrolledLabelsPanel } from './ManageEnrolledLabels/ManageEnrolledLabelsPanel';
import { useDataPoliciesTable } from './useDataPoliciesTable';

const description =
  'Data policies decide which rows a role may see. Each policy admits entities ' +
  'whose RBAC-enrolled labels match its condition. Impact counts the guarded ' +
  'entities admitted in the active snapshot.';

export const DataPoliciesPage = () => {
  const table = useDataPoliciesTable();

  return (
    <div className='flex min-h-0 flex-1 flex-col p'>
      <Card className='flex min-h-0 flex-1 flex-col' noShadow>
        {renderQuery({
          query: table.policiesQuery,
          renderStaleDataOnMount: true,
          success: () => (
            <Table
              borderless
              className='flex-1 bg-transparent'
              columns={table.columns}
              description={description}
              disableTableRowDetail
              id='settings-administration-data-policies'
              loadRowIdsForSelectAll='fromData'
              menuItems={table.menuItems}
              rowHeight={44}
              rowIdField='id'
              title='List of data policies'
              {...table.frontendSimpleFilter}
            />
          ),
        })}
      </Card>
      {table.confirmDeleteDialog.render()}
      {table.opened && (
        <DataPolicyForm
          mode={table.opened.mode}
          policy={table.opened.policy}
          onClose={() => table.setOpened(null)}
        />
      )}
      {table.managingLabels && (
        <ManageEnrolledLabelsPanel
          onClose={() => table.setManagingLabels(false)}
        />
      )}
    </div>
  );
};
